/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { combineEpics } from 'redux-observable';
import { EpicDeletePortalWebsites } from 'src/js/redux/epics/portal/EpicDeletePortalWebsites';
import { EpicGetPublicProperties } from 'src/js/redux/epics/system/EpicGetPublicProperties';
import { EpicGetGA4WebStreams } from './google/EpicGetGA4WebStreams';
import { EpicGetPortalWebsites } from 'src/js/redux/epics/portal/EpicGetPortalWebsites';
import { EpicUpdatePortalWebsite } from 'src/js/redux/epics/portal/EpicUpdatePortalWebsite';
import { EpicCheckSiteName } from './sites/EpicCheckSiteName';
import { EpicCreateCollege } from './college/EpicCreateCollege';
import { EpicGetSites } from './sites/EpicGetSites';
import { EpicGetCollegeKey } from './college/EpicGetCollegeKey';
import { EpicUpdateCollegeSites } from './sites/EpicUpdateCollegeSites';
import { EpicGetGTMandGAAccounts } from './google/EpicGetGTMandGAAccounts';
import { EpicGetGTMDataByAccount } from './google/EpicGetGTMDataByAccount';
import { EpicGetGAWebPropertiesByAccount } from './google/EpicGetGAWebPropertiesByAccount';
import { EpicGetGAProfilesByAccount } from './google/EpicGetGAProfilesByAccount';
import { EpicConfigGoogleServicesForSite } from './google/EpicConfigGoogleServicesForSite';
import { EpicGetSettings } from './settings/EpicGetSettings';
import { EpicUpdateSettings } from './settings/EpicUpdateSettings';
import { EpicGetSystemProperties } from './system/EpicGetSystemProperties';
import { EpicGetTags } from './settings/EpicGetTags';

export const EpicRoot = combineEpics(
  EpicGetGAProfilesByAccount,
  EpicGetGAWebPropertiesByAccount,
  EpicGetGTMDataByAccount,
  EpicGetGA4WebStreams,
  EpicUpdateCollegeSites,
  EpicCheckSiteName,
  EpicCreateCollege,
  EpicGetSites,
  EpicGetCollegeKey,
  EpicGetGTMandGAAccounts,
  EpicConfigGoogleServicesForSite,
  EpicGetSettings,
  EpicUpdateSettings,
  EpicGetTags,
  EpicGetPublicProperties,
  EpicGetSystemProperties,
  EpicUpdatePortalWebsite,
  EpicDeletePortalWebsites,
  EpicGetPortalWebsites
);
